import { Button } from '@/components/atoms/PcButton';
import ExcelIcon from '@/assets/icons/Monitoring/ExcelIcon.svg?react';
import { useMonitoringGoods } from './MonitoringContext';
import { useSearchParams } from 'react-router-dom';
import { useToast } from '@/hooks/V3/useToast';

import { makeExcel_keywordRankingTable } from './MakeExcelFile';
import { useMembershipMonitoringPreviewTutorial } from '@/components/membership/MembershipMonitoringPreviewTutorial';

const MakeExcelButton = ({ isMockGoods }: { isMockGoods: boolean }) => {
  const [searchParams] = useSearchParams();
  const { showToast } = useToast();
  const { openTutorial } = useMembershipMonitoringPreviewTutorial();

  const goodsNo = searchParams.get('select');
  const { goods } = useMonitoringGoods();
  const selectedGoods = goods.find((item) => String(item.GoodsNo) === String(goodsNo));

  // 엑셀 다운로드 핸들러
  const handleDownloadExcel = () => {
    if (openTutorial('downloadExcel')) return;

    if (isMockGoods) {
      showToast('warning', '예시 상품은 엑셀파일을 만들 수 없어요');
      return;
    }
    if (!selectedGoods) return;
    makeExcel_keywordRankingTable(selectedGoods.MonitoringGoodsDetailDailyList);
  };

  return (
    <Button
      variant="outline"
      size="icon"
      className="h-[34px] w-[34px] p-[7px] shadow-none"
      onClick={handleDownloadExcel}
    >
      <ExcelIcon />
    </Button>
  );
};

export default MakeExcelButton;
